<template>
    <div @click="$emit('click')">
        <a
            v-if="tag === 'a' && !dynamicData"
            :href="to"
            :class="{ 'ui-link-btn': true, '--size-small': isSizeSmall }"
            rel="nofollow"
        >
            <span>{{ title }}</span>
        </a>
        <a v-else-if="dynamicData" :href="to" :class="{ 'ui-link-btn': true, '--size-small': isSizeSmall }" rel="nofollow">
            <span
                :class="{ active: setActiveClass(dynamicData.link) }"
                :style="getAnchorStyle(dynamicData)"
                @mouseover="handleMouseOver($event, dynamicData)"
                @mouseleave="handleMouseLeave($event, dynamicData)"
                >{{ title }}</span
            >
        </a>
        <NuxtLink
            v-else
            :to="to"
            :class="{ 'ui-link-btn': true, '--size-small': isSizeSmall }"
            exact
            @click.native="$emit('on-click')"
        >
            <span>{{ title }}</span>
        </NuxtLink>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapGetters } from 'vuex';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    name: 'MyLinkBtn',
    mixins: [HeaderNavigationMixin],
    props: {
        title: VueTypes.string.def(''),
        to: VueTypes.string.def(''),
        size: VueTypes.oneOf(['default', 'small']).def('default'),
        tag: VueTypes.oneOf(['default', 'a']).def('default'),
        dynamicData: VueTypes.object.def(null),
        dynamicMobileSize: VueTypes.string.def(null)
    },
    computed: {
        ...mapGetters({
            getCurrentTheme: 'global/getCurrentTheme'
        }),
        isSizeSmall() {
            return this.size === 'small' ? true : false;
        }
    },
    inheritAttrs: false
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
